<div class="search-field" #searchFieldContainer>
  <!-- Label and required text row -->
  @if (label()) {
    <div class="search-field__header">
      <label class="search-field__label">
        {{ label() }}
        @if (required()) {
          <span class="search-field__required-indicator">*</span>
        }
      </label>
      @if (required() && showRequiredText()) {
        <p class="search-field__required-text">
          {{ requiredText() }}
        </p>
      }
    </div>
  }

  <!-- Search input box -->
  <div class="search-field__input-container" [class.search-field__input-container--error]="showError()">
    <input
      #searchInput
      type="text"
      class="search-field__input"
      [class.search-field__input--error]="showError()"
      [placeholder]="effectivePlaceholder()"
      [value]="searchText()"
      [disabled]="disabled()"
      (input)="onInput($event)"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      (keydown)="onInputKeyDown($event)"
      autocomplete="off"
    />

    @if (searchText() && !disabled()) {
      <button
        class="search-field__clear-button"
        (click)="clearSearch()"
        type="button"
        aria-label="Clear search">
        <app-icon name="close" [size]="6" color="white" />
      </button>
    } @else if (showSearchIcon()) {
      <svg class="search-field__search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 14L11.1 11.1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    }

    <!-- Dropdown positioned below or above the input -->
    <div
      class="search-field__dropdown-wrapper"
      [class.search-field__dropdown-wrapper--above]="dropdownOpenAbove()">
      <app-dropdown
        #dropdown
        [items]="filteredItems()"
        [isOpen]="isDropdownOpen()"
        [maxHeight]="dropdownMaxHeight()"
        [openAbove]="dropdownOpenAbove()"
        (itemSelected)="onItemSelected($event)"
        (closed)="closeDropdown()">
      </app-dropdown>
    </div>
  </div>

  <!-- Error message -->
  @if (showError() && errorMessage()) {
    <p class="search-field__error-message">
      {{ errorMessage() }}
    </p>
  }
</div>
